<form [formGroup]='movingDate'
      (ngSubmit)='onSubmit()'
      id='{{formGroupName}}'>

	<div class='step-title' i18n><span class='color-blue'>When</span> are you moving?</div>

	<div class='step-text'>
		<p i18n>Don't have a date yet? Select the earliest date you can move.</p>
	</div>

	<!-- Hide because tabindex doesn't work for this field -->
	<div class='form-control' [hidden]='!movingDate.controls["_shouldShow"].value'>
		<mat-calendar
			[minDate]='startDate'
			[selected]='selectedDate'
			(selectedChange)='onSelect($event)'
			[headerComponent]='customDatePickerHeader'>
		</mat-calendar>
	</div>

	<mat-error *ngIf="showRequiredError" class='required-error' i18n>Please select a date</mat-error>

	<div class='mobile-notes' *ngIf='formService.showNote'>
		<div class='note' i18n='@@movingDateTooFarAway'>Note: If your move is more than 9 months away, moving companies cannot yet provide you with a quote</div>
	</div>

	<!-- Only on mobile -->
	<div class='step-footer step-footer-center'>

		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'><mat-icon svgIcon='icons:chevron-left'></mat-icon><ng-container i18n='@@buttonBack'>Back</ng-container></button>
			<button class='submit' type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>
		</div>

	</div>
</form>